import React from "react";
import { Line } from "react-chartjs-2";
import "./AdminDashboardHome.css";

// "Operational Performance" trend chart (Admin Command Centre redesign).
// Thin Chart.js wrapper -- ChartJS.register(...) happens once in
// AdminDashboard.js, the only place this is rendered.
const GRANULARITY_OPTIONS = [["daily", "Daily"], ["weekly", "Weekly"], ["monthly", "Monthly"]];

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: { mode: "index", intersect: false },
  plugins: { legend: { position: "bottom", labels: { boxWidth: 10, font: { size: 10.5 }, padding: 10 } } },
  scales: {
    y: { beginAtZero: true, ticks: { precision: 0, font: { size: 10 } } },
    x: { ticks: { font: { size: 10 } } },
  },
};

export default function TrendChartCard({ granularity, onGranularityChange, chartData, loading, hasData }) {
  return (
    <div className="adh-card">
      <div className="adh-card-head">
        <h3 className="adh-section-title"><i className="fa-solid fa-chart-line" aria-hidden="true"></i>Operational Performance</h3>
        <div className="adh-pill-group adh-pill-group--sm" role="group" aria-label="Trend granularity">
          {GRANULARITY_OPTIONS.map(([key, label]) => (
            <button
              key={key}
              type="button"
              aria-pressed={granularity === key}
              className={`adh-pill-btn${granularity === key ? " adh-pill-btn--active" : ""}`}
              onClick={() => onGranularityChange(key)}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
      {loading ? (
        <div className="adh-card-empty"><i className="fa-solid fa-spinner fa-spin" aria-hidden="true"></i></div>
      ) : !hasData ? (
        <div className="adh-card-empty">
          <i className="fa-solid fa-chart-line" aria-hidden="true"></i>
          <p>No task activity in the current view.</p>
        </div>
      ) : (
        <div className="adh-chartbox">
          <Line data={chartData} options={chartOptions} />
        </div>
      )}
    </div>
  );
}
